import React, { useState, useEffect } from 'react';
import { ChevronUp, Mail, Menu, X, ExternalLink, Code, Cpu, Globe, Zap, Phone } from 'lucide-react';

// Componentes de ícones sociais
const LinkedInIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

const copy = {
  badge: 'Sysmath · Contagem, MG',
  h1a: 'Sistemas, sites e automações',
  h1b: 'para o seu negócio',
  subtitle:
    'Desenvolvemos sistemas, sites e automações sob medida — e acompanhamos depois do ar.',
  aboutLead:
    'A Sysmath fica em Contagem, MG. Fazemos sistemas e presença digital para empresas que precisam de ferramenta no dia a dia, não só de um site bonito. Do briefing ao go-live, e na manutenção depois.',
  aboutCards: [
    {
      title: 'Entendemos o problema',
      text: 'Começamos pelo que trava o seu processo. O sistema nasce disso, não de um pacote genérico.',
    },
    {
      title: 'Entregamos no ar',
      text: 'API, painel, SSL e hospedagem entram juntos. Você usa no celular e no computador.',
    },
    {
      title: 'Ficamos no suporte',
      text: 'Corrigimos, renovamos certificado e evoluímos o que já está rodando.',
    },
  ],
  servicesLead: 'Do aplicativo à automação: o que sua operação precisa para funcionar online.',
  contactLead: 'Quer um sistema ou site sob medida? Chama no WhatsApp ou no e-mail.',
  contactCardText: 'Resposta em horário comercial. WhatsApp é o caminho mais rápido.',
  footerTagline: 'Sistemas e sites para o seu negócio · Contagem, MG',
  year: '2026',
};

const SysMathWebsite = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollY(currentScrollY);
      setShowScrollTop(currentScrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navbarOpacity = Math.min(scrollY / 100, 1);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FEFEFE' }}>
      <style>{`
        @keyframes expandLine {
          0%, 100% { width: 0%; opacity: 0; }
          50% { width: 100%; opacity: 1; }
        }
        @keyframes expandVertical {
          0%, 100% { height: 0%; opacity: 0; }
          50% { height: 100%; opacity: 1; }
        }
        @keyframes gradientShift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        .gradient-bg {
          background: linear-gradient(-45deg, #000000, #8551FC, #000000, #14A2F4, #000000, #8551FC, #000000);
          background-size: 400% 400%;
          animation: gradientShift 15s ease infinite;
        }
        @keyframes snakeBorder {
          0% {
            box-shadow: 0 0 0 2px transparent, 0 0 0 2px transparent, 0 0 0 2px transparent, 0 0 0 2px rgba(20, 162, 244, 0.8);
          }
          25% {
            box-shadow: 2px 0 0 0 rgba(20, 162, 244, 0.8), 0 0 0 2px transparent, 0 0 0 2px transparent, 0 0 0 2px transparent;
          }
          50% {
            box-shadow: 2px 0 0 0 rgba(20, 162, 244, 0.8), 0 2px 0 0 rgba(20, 162, 244, 0.8), 0 0 0 2px transparent, 0 0 0 2px transparent;
          }
          75% {
            box-shadow: 2px 0 0 0 rgba(20, 162, 244, 0.8), 0 2px 0 0 rgba(20, 162, 244, 0.8), -2px 0 0 0 rgba(20, 162, 244, 0.8), 0 0 0 2px transparent;
          }
          100% {
            box-shadow: 2px 0 0 0 rgba(20, 162, 244, 0.8), 0 2px 0 0 rgba(20, 162, 244, 0.8), -2px 0 0 0 rgba(20, 162, 244, 0.8), 0 -2px 0 0 rgba(20, 162, 244, 0.8);
          }
        }
        @keyframes snakeBorderDark {
          0% {
            box-shadow: 0 0 0 2px transparent, 0 0 0 2px transparent, 0 0 0 2px transparent, 0 0 0 2px rgba(30, 41, 59, 0.8);
          }
          25% {
            box-shadow: 2px 0 0 0 rgba(30, 41, 59, 0.8), 0 0 0 2px transparent, 0 0 0 2px transparent, 0 0 0 2px transparent;
          }
          50% {
            box-shadow: 2px 0 0 0 rgba(30, 41, 59, 0.8), 0 2px 0 0 rgba(30, 41, 59, 0.8), 0 0 0 2px transparent, 0 0 0 2px transparent;
          }
          75% {
            box-shadow: 2px 0 0 0 rgba(30, 41, 59, 0.8), 0 2px 0 0 rgba(30, 41, 59, 0.8), -2px 0 0 0 rgba(30, 41, 59, 0.8), 0 0 0 2px transparent;
          }
          100% {
            box-shadow: 2px 0 0 0 rgba(30, 41, 59, 0.8), 0 2px 0 0 rgba(30, 41, 59, 0.8), -2px 0 0 0 rgba(30, 41, 59, 0.8), 0 -2px 0 0 rgba(30, 41, 59, 0.8);
          }
        }
        .snake-border {
          position: relative;
          border-radius: 4px;
          animation: snakeBorder 4s linear infinite;
        }
        .snake-border-dark {
          position: relative;
          border-radius: 4px;
          animation: snakeBorderDark 4s linear infinite;
        }
      `}</style>
      
      {/* Navigation */}
      <nav 
        className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-sm transition-all duration-300 ${
          scrollY > 50 ? 'shadow-lg border-b' : ''
        }`}
        style={{
          backgroundColor: scrollY > 50 ? `rgba(255, 255, 255, ${navbarOpacity * 0.95})` : 'transparent',
          borderBottomColor: scrollY > 50 ? `rgba(229, 231, 235, ${navbarOpacity * 0.5})` : 'transparent'
        }}
      >
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
          <div className="flex justify-between items-center h-14 sm:h-16">
            <div 
              className="flex items-center cursor-pointer hover:scale-105 transition-transform gap-2 sm:gap-3"
              onClick={() => scrollToSection('home')}
            >
              <img 
                src="/SYSMATH.png" 
                alt="SYSMATH Logo" 
                className="h-10 sm:h-12 md:h-14 object-contain"
              />
              <span 
                className={`text-xl sm:text-2xl md:text-3xl font-neue-kaine transition-colors duration-300 ${
                  scrollY <= 50 ? 'text-white' : 'text-gray-900'
                }`}
              >
                <span className="font-bold">sys</span>math
              </span>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('home')} 
                className={`font-medium transition-all duration-300 px-3 py-1 hover:scale-110 ${scrollY <= 50 ? 'text-white snake-border hover:text-sysmath-blue' : 'text-gray-700 hover:text-sysmath-purple snake-border-dark'}`}
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')} 
                className={`font-medium transition-all duration-300 px-3 py-1 hover:scale-110 ${scrollY <= 50 ? 'text-white snake-border hover:text-sysmath-blue' : 'text-gray-700 hover:text-sysmath-purple snake-border-dark'}`}
              >
                Sobre
              </button>
              <button 
                onClick={() => scrollToSection('services')} 
                className={`font-medium transition-all duration-300 px-3 py-1 hover:scale-110 ${scrollY <= 50 ? 'text-white snake-border hover:text-sysmath-blue' : 'text-gray-700 hover:text-sysmath-purple snake-border-dark'}`}
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('contact')} 
                className={`font-medium transition-all duration-300 px-3 py-1 hover:scale-110 ${scrollY <= 50 ? 'text-white snake-border hover:text-sysmath-blue' : 'text-gray-700 hover:text-sysmath-purple snake-border-dark'}`}
              >
                Contato
              </button>
              
              <div className={`w-px h-6 transition-all duration-300 ${scrollY <= 50 ? 'bg-white/30' : 'bg-gray-300'}`}></div>
              
              <div className="flex items-center space-x-3">
                <a
                  href="https://linkedin.com/company/sysmath"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Abrir o LinkedIn da Sysmath em uma nova aba"
                  className="p-2 rounded-lg bg-blue-50 text-blue-600 hover:bg-blue-600 hover:text-white transform hover:scale-110 transition-all duration-300"
                >
                  <LinkedInIcon />
                </a>
                <a
                  href="https://instagram.com/sys.math"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Abrir o Instagram da Sysmath em uma nova aba"
                  className="p-2 rounded-lg bg-pink-50 text-pink-600 hover:bg-gradient-to-r hover:from-purple-600 hover:to-pink-600 hover:text-white transform hover:scale-110 transition-all duration-300"
                >
                  <InstagramIcon />
                </a>
                <a
                  href="https://api.whatsapp.com/send?phone=5531992905100"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Conversar com a Sysmath pelo WhatsApp"
                  className="p-2 rounded-lg bg-green-50 text-green-600 hover:bg-green-600 hover:text-white transform hover:scale-110 transition-all duration-300"
                >
                  <WhatsAppIcon />
                </a>
              </div>
            </div>

            <div className="md:hidden">
              <button 
                onClick={() => setIsMenuOpen(!isMenuOpen)} 
                className={`p-2 rounded-md transition-colors ${scrollY <= 50 ? 'text-white hover:bg-white/10' : 'text-gray-700 hover:text-blue-600 hover:bg-gray-100'}`}
              >
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div 
              className={`md:hidden backdrop-blur-sm transition-all duration-300 ${
                scrollY > 50 ? 'border-t' : ''
              }`}
              style={{
                backgroundColor: scrollY > 50 ? `rgba(255, 255, 255, 0.95)` : `rgba(0, 0, 0, 0.3)`,
                borderTopColor: scrollY > 50 ? `rgba(229, 231, 235, 0.5)` : 'transparent'
              }}
            >
              <div className="px-2 pt-2 pb-3 space-y-1">
                <button 
                  onClick={() => scrollToSection('home')} 
                  className={`block w-full text-left px-3 py-2 font-medium transition-all duration-300 hover:scale-105 ${
                    scrollY <= 50 ? 'text-white hover:text-sysmath-blue' : 'text-slate-800 hover:text-sysmath-purple'
                  }`}
                >
                  Home
                </button>
                <button 
                  onClick={() => scrollToSection('about')} 
                  className={`block w-full text-left px-3 py-2 font-medium transition-all duration-300 hover:scale-105 ${
                    scrollY <= 50 ? 'text-white hover:text-sysmath-blue' : 'text-slate-800 hover:text-sysmath-purple'
                  }`}
                >
                  Sobre
                </button>
                <button 
                  onClick={() => scrollToSection('services')} 
                  className={`block w-full text-left px-3 py-2 font-medium transition-all duration-300 hover:scale-105 ${
                    scrollY <= 50 ? 'text-white hover:text-sysmath-blue' : 'text-slate-800 hover:text-sysmath-purple'
                  }`}
                >
                  Serviços
                </button>
                <button 
                  onClick={() => scrollToSection('contact')} 
                  className={`block w-full text-left px-3 py-2 font-medium transition-all duration-300 hover:scale-105 ${
                    scrollY <= 50 ? 'text-white hover:text-sysmath-blue' : 'text-slate-800 hover:text-sysmath-purple'
                  }`}
                >
                  Contato
                </button>
                
                <div className={`flex items-center justify-center space-x-4 pt-4 mt-4 ${
                  scrollY <= 50 ? 'border-t border-white/20' : 'border-t border-gray-200'
                }`}>
                  <a
                    href="https://linkedin.com/company/sysmath"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Abrir o LinkedIn da Sysmath em uma nova aba"
                    className={`p-2 rounded-lg transform hover:scale-110 transition-all duration-300 ${
                      scrollY <= 50 
                        ? 'bg-white/10 text-white' 
                        : ''
                    }`}
                  >
                    <LinkedInIcon />
                  </a>
                  <a
                    href="https://instagram.com/sys.math"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Abrir o Instagram da Sysmath em uma nova aba"
                    className={`p-2 rounded-lg transform hover:scale-110 transition-all duration-300 ${
                      scrollY <= 50 
                        ? 'bg-white/10 text-white' 
                        : ''
                    }`}
                  >
                    <InstagramIcon />
                  </a>
                  <a
                    href="https://api.whatsapp.com/send?phone=5531992905100"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Conversar com a Sysmath pelo WhatsApp"
                    className={`p-2 rounded-lg transform hover:scale-110 transition-all duration-300 ${
                      scrollY <= 50 
                        ? 'bg-white/10 text-white' 
                        : ''
                    }`}
                  >
                    <WhatsAppIcon />
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="pt-16 min-h-screen relative overflow-hidden gradient-bg">
        <div className="absolute inset-0">
          <div className="absolute inset-0">
            {[...Array(30)].map((_, i) => (
              <div
                key={i}
                className="absolute bg-white rounded-full opacity-20 animate-pulse"
                style={{
                  left: Math.random() * 100 + '%',
                  top: Math.random() * 100 + '%',
                  width: Math.random() * 3 + 1 + 'px',
                  height: Math.random() * 3 + 1 + 'px',
                  animationDelay: Math.random() * 3 + 's',
                  animationDuration: Math.random() * 3 + 2 + 's'
                }}
              />
            ))}
          </div>
          
          <div className="absolute inset-0 opacity-20">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <pattern id="grid" width="50" height="50" patternUnits="userSpaceOnUse">
                  <path d="M 50 0 L 0 0 0 50" fill="none" stroke="rgba(139, 92, 246, 0.3)" strokeWidth="1"/>
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#grid)" />
            </svg>
          </div>
          
          <div className="absolute top-1/4 left-1/4 w-32 h-32 rounded-full blur-xl animate-pulse" style={{backgroundColor: 'rgba(20, 162, 244, 0.2)'}}></div>
          <div className="absolute top-3/4 right-1/4 w-24 h-24 rounded-full blur-xl animate-pulse" style={{backgroundColor: 'rgba(133, 81, 252, 0.2)', animationDelay: '1s'}}></div>
          <div className="absolute top-1/2 left-3/4 w-28 h-28 rounded-full blur-xl animate-pulse" style={{backgroundColor: 'rgba(20, 162, 244, 0.2)', animationDelay: '2s'}}></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 flex items-center min-h-screen">
          <div className="text-center w-full">
            <div className="mb-6 sm:mb-8">
              <div className="inline-flex items-center px-3 sm:px-4 py-1.5 sm:py-2 rounded-full backdrop-blur-sm text-xs sm:text-sm font-medium mb-4 sm:mb-6" style={{backgroundColor: 'rgba(20, 162, 244, 0.2)', border: '1px solid rgba(20, 162, 244, 0.3)', color: 'rgba(254, 254, 254, 0.9)'}}>
                <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full mr-2 animate-pulse" style={{backgroundColor: '#14A2F4'}}></span>
                {copy.badge}
              </div>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl mb-4 sm:mb-6 px-4 font-neue-kaine">
              <span className="bg-clip-text text-transparent font-bold" style={{background: 'linear-gradient(to right, #14A2F4, #8551FC, #14A2F4)', WebkitBackgroundClip: 'text'}}>
                {copy.h1a}
              </span>
              <br />
              <span className="text-white drop-shadow-lg">{copy.h1b}</span>
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-6 sm:mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed px-4">
              {copy.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4">
              <button
                onClick={() => scrollToSection('contact')}
                className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 text-white text-sm sm:text-base font-semibold rounded-full hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
                style={{background: 'linear-gradient(to right, #14A2F4, #8551FC)'}}
              >
                Entre em contato
                <ExternalLink className="ml-2 w-4 h-4 sm:w-5 sm:h-5 inline" />
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 border-2 text-sm sm:text-base font-semibold rounded-full backdrop-blur-sm transition-all duration-300"
                style={{borderColor: 'rgba(133, 81, 252, 0.5)', color: 'rgba(254, 254, 254, 0.9)'}}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(133, 81, 252, 0.1)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
              >
                Nossos Serviços
              </button>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-40" style={{background: 'linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.6), #000000)'}}></div>
        
        {/* Efeito de ondas para transição */}
        <div className="absolute bottom-0 left-0 right-0 h-20 overflow-hidden">
          <svg className="absolute bottom-0 w-full h-20" preserveAspectRatio="none" viewBox="0 0 1200 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,60 C150,100 350,0 600,60 C850,120 1050,20 1200,60 L1200,120 L0,120 Z" fill="rgba(0, 0, 0, 0.8)"/>
          </svg>
          <svg className="absolute bottom-0 w-full h-16" preserveAspectRatio="none" viewBox="0 0 1200 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,80 C200,120 400,40 600,80 C800,120 1000,40 1200,80 L1200,120 L0,120 Z" fill="#000000"/>
          </svg>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 relative overflow-hidden" style={{background: 'linear-gradient(to bottom right, #000000, #000000)'}}>
        {/* Transição suave da seção anterior */}
        <div className="absolute top-0 left-0 right-0 h-20" style={{background: 'linear-gradient(to bottom, #000000, transparent)'}}></div>
        
        <div className="absolute inset-0">
          <div className="absolute inset-0">
            <div className="absolute top-1/4 left-0 w-full h-px">
              <div className="w-0 h-full" style={{
                background: 'linear-gradient(to right, rgba(20, 162, 244, 0.5), rgba(133, 81, 252, 0.5))',
                animation: 'expandLine 3s ease-in-out infinite',
                animationDelay: '0s'
              }}></div>
            </div>
            <div className="absolute top-1/2 left-0 w-full h-px">
              <div className="w-0 h-full" style={{
                background: 'linear-gradient(to right, rgba(133, 81, 252, 0.5), rgba(20, 162, 244, 0.5))',
                animation: 'expandLine 3s ease-in-out infinite',
                animationDelay: '1s'
              }}></div>
            </div>
            <div className="absolute top-3/4 left-0 w-full h-px">
              <div className="w-0 h-full" style={{
                background: 'linear-gradient(to right, rgba(133, 81, 252, 0.5), rgba(20, 162, 244, 0.5))',
                animation: 'expandLine 3s ease-in-out infinite',
                animationDelay: '2s'
              }}></div>
            </div>
            
            <div className="absolute top-0 left-1/4 w-px h-full">
              <div className="w-full h-0" style={{
                background: 'linear-gradient(to bottom, rgba(20, 162, 244, 0.4), rgba(133, 81, 252, 0.4))',
                animation: 'expandVertical 4s ease-in-out infinite',
                animationDelay: '0.5s'
              }}></div>
            </div>
            <div className="absolute top-0 left-1/2 w-px h-full">
              <div className="w-full h-0" style={{
                background: 'linear-gradient(to bottom, rgba(20, 162, 244, 0.4), rgba(133, 81, 252, 0.4))',
                animation: 'expandVertical 4s ease-in-out infinite',
                animationDelay: '1.5s'
              }}></div>
            </div>
            <div className="absolute top-0 left-3/4 w-px h-full">
              <div className="w-full h-0" style={{
                background: 'linear-gradient(to bottom, rgba(133, 81, 252, 0.4), rgba(20, 162, 244, 0.4))',
                animation: 'expandVertical 4s ease-in-out infinite',
                animationDelay: '2.5s'
              }}></div>
            </div>
          </div>
          
          <div className="absolute inset-0 opacity-20">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <pattern id="techGrid" width="40" height="40" patternUnits="userSpaceOnUse">
                  <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(20, 162, 244, 0.3)" strokeWidth="1"/>
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#techGrid)" />
            </svg>
          </div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16">
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6 px-4 font-neue-kaine">
              Sobre <span className="bg-clip-text text-transparent" style={{background: 'linear-gradient(to right, #14A2F4, #8551FC)', WebkitBackgroundClip: 'text'}}>nós</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl max-w-3xl mx-auto leading-relaxed px-4" style={{color: 'rgba(20, 162, 244, 0.9)'}}>
              {copy.aboutLead}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8 max-w-5xl mx-auto">
            <div className="group">
              <div className="bg-white/10 backdrop-blur-sm border rounded-xl sm:rounded-2xl p-6 sm:p-8 hover:bg-white/15 transition-all duration-300 hover:-translate-y-2 h-full flex flex-col" style={{borderColor: 'rgba(20, 162, 244, 0.2)'}} onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(20, 162, 244, 0.4)'; }} onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(20, 162, 244, 0.2)'; }}>
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform flex-shrink-0 mx-auto" style={{background: 'linear-gradient(to bottom right, #14A2F4, #8551FC)'}}>
                  <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <div className="flex flex-col h-full">
                  <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4 text-center font-neue-kaine">{copy.aboutCards[0].title}</h3>
                  <p className="text-sm sm:text-base leading-relaxed text-center flex-grow flex items-center" style={{color: 'rgba(20, 162, 244, 0.9)'}}>
                    {copy.aboutCards[0].text}
                  </p>
                </div>
              </div>
            </div>

            <div className="group">
              <div className="bg-white/10 backdrop-blur-sm border rounded-xl sm:rounded-2xl p-6 sm:p-8 hover:bg-white/15 transition-all duration-300 hover:-translate-y-2 h-full flex flex-col" style={{borderColor: 'rgba(133, 81, 252, 0.2)'}} onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(133, 81, 252, 0.4)'; }} onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(133, 81, 252, 0.2)'; }}>
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform flex-shrink-0 mx-auto" style={{background: 'linear-gradient(to bottom right, #8551FC, #8551FC)'}}>
                  <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                  </svg>
                </div>
                <div className="flex flex-col h-full">
                  <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4 text-center font-neue-kaine">{copy.aboutCards[1].title}</h3>
                  <p className="text-sm sm:text-base leading-relaxed text-center flex-grow flex items-center" style={{color: 'rgba(20, 162, 244, 0.9)'}}>
                    {copy.aboutCards[1].text}
                  </p>
                </div>
              </div>
            </div>

            <div className="group sm:col-span-2 md:col-span-1">
              <div className="bg-white/10 backdrop-blur-sm border rounded-xl sm:rounded-2xl p-6 sm:p-8 hover:bg-white/15 transition-all duration-300 hover:-translate-y-2 h-full flex flex-col" style={{borderColor: 'rgba(20, 162, 244, 0.2)'}} onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(20, 162, 244, 0.4)'; }} onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(20, 162, 244, 0.2)'; }}>
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform flex-shrink-0 mx-auto" style={{background: 'linear-gradient(to bottom right, #14A2F4, #8551FC)'}}>
                  <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <div className="flex flex-col h-full">
                  <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4 text-center font-neue-kaine">{copy.aboutCards[2].title}</h3>
                  <p className="text-sm sm:text-base leading-relaxed text-center flex-grow flex items-center" style={{color: 'rgba(20, 162, 244, 0.9)'}}>
                    {copy.aboutCards[2].text}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-32" style={{background: 'linear-gradient(to bottom, transparent, rgba(254, 254, 254, 0.7))'}}></div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-12 sm:py-16 md:py-20 relative" style={{background: 'linear-gradient(to bottom right, #FEFEFE, #FEFEFE)'}}>
        <div className="absolute top-0 left-0 right-0 h-32" style={{background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.3), transparent)'}}></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16">
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl text-gray-900 mb-4 sm:mb-6 px-4">
              <span className="font-neue-kaine" style={{fontWeight: 'normal'}}>Nossos</span> <span className="bg-clip-text text-transparent font-neue-kaine" style={{background: 'linear-gradient(to right, #14A2F4, #8551FC)', WebkitBackgroundClip: 'text', fontFamily: "'Neue-kaine', 'PF Square Sans Pro', sans-serif", fontWeight: 'normal'}}>Serviços</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
              {copy.servicesLead}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
            <div className="group">
              <div className="rounded-xl sm:rounded-2xl p-5 sm:p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 h-full flex flex-col border" style={{background: 'linear-gradient(to bottom right, rgba(20, 162, 244, 0.08), rgba(20, 162, 244, 0.15))', borderColor: 'rgba(20, 162, 244, 0.25)'}}>
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform flex-shrink-0" style={{background: 'linear-gradient(to bottom right, #14A2F4, #14A2F4)'}}>
                  <Code className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
                </div>
                <div className="flex flex-col h-full">
                  <h3 className="text-lg sm:text-xl text-gray-900 mb-3 sm:mb-4 font-neue-kaine" style={{fontFamily: "'Neue-kaine', 'PF Square Sans Pro', sans-serif", fontWeight: 'normal'}}>Construção de APIs</h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed flex-grow">
                    Desenvolvemos APIs robustas e escaláveis para integrar seus sistemas e facilitar a comunicação entre aplicações.
                  </p>
                </div>
              </div>
            </div>

            <div className="group">
              <div className="rounded-xl sm:rounded-2xl p-5 sm:p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 h-full flex flex-col border" style={{background: 'linear-gradient(to bottom right, rgba(133, 81, 252, 0.08), rgba(133, 81, 252, 0.15))', borderColor: 'rgba(133, 81, 252, 0.25)'}}>
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform flex-shrink-0" style={{background: 'linear-gradient(to bottom right, #8551FC, #8551FC)'}}>
                  <Cpu className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
                </div>
                <div className="flex flex-col h-full">
                  <h3 className="text-lg sm:text-xl text-gray-900 mb-3 sm:mb-4 font-neue-kaine" style={{fontWeight: 'normal'}}>Automação</h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed flex-grow">
                    Automatizamos processos repetitivos e otimizamos workflows para aumentar a eficiência do seu negócio.
                  </p>
                </div>
              </div>
            </div>

            <div className="group">
              <div className="rounded-xl sm:rounded-2xl p-5 sm:p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 h-full flex flex-col border" style={{background: 'linear-gradient(to bottom right, rgba(20, 162, 244, 0.08), rgba(133, 81, 252, 0.08))', borderColor: 'rgba(20, 162, 244, 0.25)'}}>
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform flex-shrink-0" style={{background: 'linear-gradient(to bottom right, #14A2F4, #8551FC)'}}>
                  <Zap className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
                </div>
                <div className="flex flex-col h-full">
                  <h3 className="text-lg sm:text-xl text-gray-900 mb-3 sm:mb-4 font-neue-kaine" style={{fontFamily: "'Neue-kaine', 'PF Square Sans Pro', sans-serif", fontWeight: 'normal'}}>Criação de Sistemas</h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed flex-grow">
                    Desenvolvemos sistemas personalizados sob medida para atender às necessidades específicas da sua empresa.
                  </p>
                </div>
              </div>
            </div>

            <div className="group">
              <div className="rounded-xl sm:rounded-2xl p-5 sm:p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 h-full flex flex-col border" style={{background: 'linear-gradient(to bottom right, rgba(133, 81, 252, 0.08), rgba(20, 162, 244, 0.08))', borderColor: 'rgba(133, 81, 252, 0.25)'}}>
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform flex-shrink-0" style={{background: 'linear-gradient(to bottom right, #8551FC, #14A2F4)'}}>
                  <Globe className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
                </div>
                <div className="flex flex-col h-full">
                  <h3 className="text-lg sm:text-xl text-gray-900 mb-3 sm:mb-4 font-neue-kaine" style={{fontWeight: 'normal'}}>Sites & Landing Pages</h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed flex-grow">
                    Criamos sites modernos, responsivos e landing pages otimizadas para conversão e resultados.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-32" style={{background: 'linear-gradient(to bottom, transparent, rgba(20, 162, 244, 0.05))'}}></div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-12 sm:py-16 md:py-20 relative" style={{background: 'linear-gradient(to bottom right, rgba(20, 162, 244, 0.03), rgba(133, 81, 252, 0.03))'}}>
        <div className="absolute top-0 left-0 right-0 h-32" style={{background: 'linear-gradient(to bottom, rgba(254, 254, 254, 0.5), transparent)'}}></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16">
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4 font-neue-kaine">
              <span className="bg-clip-text text-transparent" style={{background: 'linear-gradient(to right, #14A2F4, #8551FC)', WebkitBackgroundClip: 'text'}}>Contato</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-4">
              {copy.contactLead}
            </p>
          </div>

          <div className="flex justify-center">
            <div className="w-full max-w-md">
              <div className="bg-white rounded-xl sm:rounded-2xl p-8 sm:p-10 shadow-lg hover:shadow-xl transition-all duration-300 border border-blue-100 text-center">
                <div className="flex flex-col items-center mb-6">
                  <div className="w-16 h-16 rounded-xl flex items-center justify-center mb-4 flex-shrink-0" style={{background: 'linear-gradient(to bottom right, #14A2F4, #8551FC)'}}>
                    <Mail className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 font-neue-kaine">Nosso contato</h3>
                  <p className="text-sm sm:text-base text-gray-600 mb-6">{copy.contactCardText}</p>
                  </div>
                <div className="pt-4 border-t border-gray-200 space-y-3">
                  <div className="flex items-center justify-center gap-2">
                    <Mail className="w-5 h-5 text-blue-600" />
                    <a href="mailto:mathaus@sysmath.com.br" className="text-base sm:text-lg text-gray-700 font-medium break-words hover:underline">
                      Email: <span style={{color: '#14A2F4'}}>mathaus@sysmath.com.br</span>
                    </a>
                </div>
                  <div className="flex items-center justify-center gap-2">
                    <Phone className="w-5 h-5 text-blue-600" />
                    <a href="tel:+5531992905100" className="text-base sm:text-lg text-gray-700 font-medium hover:underline">
                      Telefone: <span style={{color: '#14A2F4'}}>(31) 9 9290-5100</span>
                    </a>
              </div>
                  <div className="flex items-center justify-center gap-2 pt-1">
                    <a
                      href="https://api.whatsapp.com/send?phone=5531992905100"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-white text-sm font-semibold"
                      style={{background: 'linear-gradient(to right, #14A2F4, #8551FC)'}}
                    >
                      Chamar no WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Efeito de ondas para transição */}
        <div className="absolute bottom-0 left-0 right-0 h-20 overflow-hidden">
          <svg className="absolute bottom-0 w-full h-20" preserveAspectRatio="none" viewBox="0 0 1200 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,60 C150,100 350,0 600,60 C850,120 1050,20 1200,60 L1200,120 L0,120 Z" fill="rgba(0, 0, 0, 0.8)"/>
          </svg>
          <svg className="absolute bottom-0 w-full h-16" preserveAspectRatio="none" viewBox="0 0 1200 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,80 C200,120 400,40 600,80 C800,120 1000,40 1200,80 L1200,120 L0,120 Z" fill="#000000"/>
          </svg>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative overflow-hidden gradient-bg text-white py-12">
        <div className="absolute top-0 left-0 right-0 h-20" style={{background: 'linear-gradient(to bottom, #000000, transparent)'}}></div>
        
        <div className="absolute inset-0">
          <div className="absolute inset-0">
            <div className="absolute top-1/4 left-0 w-full h-px">
              <div className="w-0 h-full" style={{
                background: 'linear-gradient(to right, rgba(133, 81, 252, 0.5), rgba(20, 162, 244, 0.5))',
                animation: 'expandLine 4s ease-in-out infinite',
                animationDelay: '0s'
              }}></div>
            </div>
            <div className="absolute top-3/4 left-0 w-full h-px">
              <div className="w-0 h-full" style={{
                background: 'linear-gradient(to right, rgba(20, 162, 244, 0.5), rgba(133, 81, 252, 0.5))',
                animation: 'expandLine 4s ease-in-out infinite',
                animationDelay: '2s'
              }}></div>
            </div>
            
            <div className="absolute top-0 left-1/3 w-px h-full">
              <div className="w-full h-0" style={{
                background: 'linear-gradient(to bottom, rgba(133, 81, 252, 0.4), rgba(20, 162, 244, 0.4))',
                animation: 'expandVertical 5s ease-in-out infinite',
                animationDelay: '1s'
              }}></div>
            </div>
            <div className="absolute top-0 left-2/3 w-px h-full">
              <div className="w-full h-0" style={{
                background: 'linear-gradient(to bottom, rgba(20, 162, 244, 0.4), rgba(133, 81, 252, 0.4))',
                animation: 'expandVertical 5s ease-in-out infinite',
                animationDelay: '3s'
              }}></div>
            </div>
          </div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16">
          <div className="text-center">
            <div className="flex items-center justify-center mb-4 sm:mb-6">
              <img 
                src="/PNG LOGO 4 BRANCA.png" 
                alt="SYSMATH Logo" 
                className="h-10 sm:h-12 object-contain"
              />
            </div>
            <p className="text-sm sm:text-base text-gray-400 mb-4 sm:mb-6 px-4">
              {copy.footerTagline}
            </p>
            <div className="pt-4 sm:pt-6">
              <p className="text-xs sm:text-sm text-gray-400 px-4">
                © {copy.year} <span className="font-bold">sys</span>math. Todos os direitos reservados.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <a
        href="https://api.whatsapp.com/send?phone=5531992905100"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Conversar com a Sysmath pelo WhatsApp"
        className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 w-14 h-14 sm:w-16 sm:h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
      >
        <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
        </svg>
      </a>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-50 w-10 h-10 sm:w-12 sm:h-12 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
          style={{backgroundColor: '#14A2F4'}}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#8551FC'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#14A2F4'; }}
        >
          <ChevronUp className="w-5 h-5 sm:w-6 sm:h-6" />
        </button>
      )}
    </div>
  );
};

export default SysMathWebsite;